<template>
    <v-menu
        ref="calendarMenu"
        v-model="calendarMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px">
        <template v-slot:activator="{ on }">
            <v-text-field dense outlined
                v-model="computed_model"
                append-icon="event"
                v-on="on"
                readonly
                v-bind="computedProps"
            ></v-text-field>
        </template>
        <v-date-picker 
            v-model="model"
            ref="year_picker"
            :reactive="true"
            no-title
            @click:year="save">
        </v-date-picker>
    </v-menu>
</template>

<script>
    import { VTextField, VDatePicker } from 'vuetify/lib';
    // import { getTimestamp, formatDatefromTS } from '../../utils/commonUtils'

    export default {
        components: { VDatePicker },
        name: 'YearField',
        extends: VTextField,

        props: {
            minYear: {
                type: String,
                default: null
            },
            maxYear: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                year: this.value,
                model: null,
                computed_model: "",
                calendarMenu: false,
            }
        },
        mounted() {
            this.setDateModel()
        },
        watch: {
            year: function(val) {
                console.log('$$$$$$$$$$$$$', val)
                this.$emit('input', val)
            },
            model: function(val) {
                if (!val) return
                this.computed_model = this.value
          
            },
            value: function(val){
                console.log('*****************', this.value, val)
            },
            calendarMenu (val) {
                val && setTimeout(() => (this.$refs.year_picker.activePicker = 'YEAR'))
            }
        },
        methods: {
            save () {
                this.calendarMenu = false
                this.year = this.model.substr(0, 4)
            },
            setDateModel () {
                if (!this.timestamp){
                  return
                }
                this.model = (new Date(this.timestamp)).toISOString().substr(0, 10)
                this.computed_model = formatDatefromTS(this.timestamp)
            }
        },
        computed: {
            computedProps() {
                return {
                    value: this.year,
                    ...this.$props
                }
            }
        }
    }
</script>